import { Stack, TextField, Typography, Box } from '@mui/material'
import { CustomTextFieldProps } from './types'

const TextInput: React.FC<CustomTextFieldProps> = ({
  label,
  InputProps,
  error = false,
  errorMessage = '',
  sxLabel,
  sxInput,
  ...props
}: CustomTextFieldProps & { sxInput?: object }) => {
  const mergedInputProps = {
    maxLength: 250,
    ...(InputProps?.inputProps || {}),
  }

  return (
    <Stack sx={{ gap: '.6rem', width: '100%' }}>
      <Box sx={{ color: '#1F1F1F', ...sxLabel }}>{label}</Box>
      <TextField
        {...props}
        variant="standard"
        InputProps={{
          disableUnderline: true,
          style: {
            fontSize: '1.6rem',
            fontWeight: 400,
            lineHeight: '2.4rem',
            padding: '0 !important',
            color: '#444444',
          },
          ...InputProps,
          inputProps: mergedInputProps,
        }}
        sx={{
          borderRadius: '.8rem',
          border: `1px solid ${error ? '#ff0000' : '#D9D9D9'}`,
          boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
          padding: '.6rem 1.4rem',
          flex: 1,
          ...sxInput,
        }}
      />
      {error && <Typography color="error">{errorMessage}</Typography>}
    </Stack>
  )
}

export default TextInput
